import { Table } from 'antd';

import { PREFIX } from '@app/constants';

import { useMedicalConsultationHistory } from '../hooks';

import type { MedicalConsultationHistoryProps } from '../types';

export const MedicalConsultationHistory = ({
  clientId,
}: MedicalConsultationHistoryProps) => {
  const { documents, isLoading, columns } = useMedicalConsultationHistory({
    clientId,
  });

  return (
    <div className={`${PREFIX}medical-consultation-history`}>
      <Table
        columns={columns}
        dataSource={documents}
        loading={isLoading}
        rowKey="Id"
        pagination={false}
        locale={{ emptyText: 'Медицинских консультаций нет' }}
      />
    </div>
  );
};
